<template>
  <div class="grid-x flex-grow object-editor-layout">
    <div class="cell large-7 cell-block-y padding-2">
      <div class="grid-y space-y-12">
        <div class="cell">
          <ObjectLocation
            :value="model.location"
            @input="($event) => model.location = Object.assign(model.location, $event)"/>
        </div>
        <div class="cell">
          <ObjectBurials
            :update="model.updateBurials"
            :create="model.createBurials"
            @update-input="($event) => model.updateBurials = $event"
            @create-input="($event) => model.createBurials = $event"/>
        </div>
      </div>
    </div>
    <div class="cell large-5 cell-block-y padding-2 flex flex-col">
      <ObjectAbout
        v-model="model.about"
        @cancel="$router.push({
          name: 'objects',
        })"
        @save="save"/>
    </div>
  </div>
</template>

<script>
import ObjectLocation from '@/pages/Objects/ObjectNew/Components/ObjectLocation.vue';
import ObjectBurials from '@/pages/Objects/ObjectNew/Components/ObjectBurials.vue';
import ObjectAbout from '@/pages/Objects/ObjectNew/Components/ObjectAbout.vue';

export default {
  props: {
    payload: {
      type: Object,
      required: false,
      default: () => ({
        location: {
          country: null,
          region: null,
          district: null,
          cemetery: null,
          fence: null,
          size: null,
          section: '',
          crypt: '',
        },
        updateBurials: [],
        createBurials: [],
        about: {
          celebrity: false,
          order: true,
        },
      }),
    },
  },
  components: {
    ObjectLocation,
    ObjectBurials,
    ObjectAbout,
  },
  data() {
    return {
      model: this.payload,
    };
  },
  computed: {
    query() {
      return {
        family: false,
        ...this.model.location,
        ...this.model.about,
        createBurials: this.model.createBurials,
        updateBurials: this.model.updateBurials,
      };
    },
  },
  methods: {
    save() {
      this.$emit('save', this.query);
    },
  },
};
</script>
